export default __webpack_public_path__ + "static/media/128x128.d310ec23.jpg";